import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetCompany, PostCompanyInfo, PostUser } from '../services/httpServices';

import { styled } from '@mui/material/styles';

// import { TextField } from '@material-ui/core';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const CompanyInforamtion = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);

  const [value, setValue] = useState('female');
  const [lmiaPriorToDec, setLmiaPriorToDec] = useState(false);
  const [lmiaAfterDec, setLmiaAfterDec] = useState(false);
  const [lmiaRevoked, setLmiaRevoked] = useState(false);
  const [haveBankAccount, setHaveBankAccount] = useState(false);
  const [company, setCompany] = useState({});
  const userNameRef = useRef('');
  const passwordRef = useRef('');

  const systemFileNumRef = useRef('');
  const revokedDateRef = useRef('');

  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    setHaveBankAccount(company.companyInformations[0].bankAccount == 'true' ? true : false);
    setLmiaPriorToDec(company.companyInformations[0].lmiapriorDec == 'true' ? true : false);
    setLmiaAfterDec(company.companyInformations[0].lmiaafterDec == 'true' ? true : false);
    setLmiaRevoked(company.companyInformations[0].lmiarevoked == 'true' ? true : false);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      bankAccount: haveBankAccount,
      userName: userNameRef.current.value,
      password: passwordRef.current.value,
      lmiapriorDec: lmiaPriorToDec,
      lmiaafterDec: lmiaAfterDec,
      lmiarevoked: lmiaRevoked,
      revokedDate: revokedDateRef.current.value,
      systemFileNumber: systemFileNumRef.current.value,
    };

    //console.log(payload);
    let response = await PostCompanyInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Company Information saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let companySaved = company;
      companySaved.companyInformations[0] = response.data;
      setCompany(companySaved);
      // console.log('companySaved.companyInformations[0]:', companySaved.companyInformations[0]);
      // setHaveBankAccount(companySaved.companyInformations[0].bankAccount ? true : false);
      setCompany(companySaved);
      //console.log('Id:', id);
      setTimeout(() => {
        navigate(`/app/CompanyTabs/${id}/${false}`);
      }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleChangeBankAccount = (event) => {
    event.target.value == 'true' ? setHaveBankAccount(true) : setHaveBankAccount(false);
    if (event.target.value == 'true') {
      // console.log('company.companyInformations[0].userName', company.companyInformations[0].userName);
      userNameRef.current.value = company.companyInformations[0]?.userName;
      passwordRef.current.value = company.companyInformations[0]?.password;
    } else {
      userNameRef.current.value = '';
      passwordRef.current.value = '';
    }
  };
  const handleChangePriorToDec = (event) => {
    event.target.value == 'true' ? setLmiaPriorToDec(true) : setLmiaPriorToDec(false);
  };
  const handleChangeAfterToDec = (event) => {
    event.target.value == 'true' ? setLmiaAfterDec(true) : setLmiaAfterDec(false);
  };
  const handleChangeLmiaRevoked = (event) => {
    event.target.value == 'true' ? setLmiaRevoked(true) : setLmiaRevoked(false);
    let date = company.companyInformations[0]?.revokedDate?.split('T')[0];
    //console.log('company.companyInformations[0].userName', date);
    if (event.target.value == 'true') {
      revokedDateRef.current.value = company.companyInformations[0]?.revokedDate?.split('T')[0];
      systemFileNumRef.current.value = company.companyInformations[0]?.systemFileNumber;
    } else {
      revokedDateRef.current.value = '';
      systemFileNumRef.current.value = '';
    }
  };
  // console.log('mmmm', company);
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Do you have an existing Job Bank Account?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={haveBankAccount}
                        onChange={handleChangeBankAccount}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid direction="column" item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes Please provide us the following:
                      </FormLabel>
                    </FormControl>

                    <Item>
                      <TextField
                        label="Username"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={company.companyInformations[0]?.userName}
                        disabled={!haveBankAccount}
                        inputRef={userNameRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="Password"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={company.companyInformations[0]?.password}
                        disabled={!haveBankAccount}
                        inputRef={passwordRef}
                      />
                    </Item>
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Did you employ a TFW (as the result of a positive LMIA) prior to December 31, 2013?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={lmiaPriorToDec}
                        onChange={handleChangePriorToDec}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you applied and received a positive LMIA on or after December 31, 2013 and employed a TFW
                        position?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={lmiaAfterDec}
                        onChange={handleChangeAfterToDec}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you had an LMIA revoked (because you had provided false, misleading or inaccurate
                        information) within the previous 2 years from the date you submitted this application?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={lmiaRevoked}
                        onChange={handleChangeLmiaRevoked}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes Please provide us the details of revocation below:
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Date"
                        type="date"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={company.companyInformations[0]?.revokedDate?.split('T')[0]}
                        disabled={!lmiaRevoked}
                        inputRef={revokedDateRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="System File Number"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={company.companyInformations[0].systemFileNumber}
                        disabled={!lmiaRevoked}
                        inputRef={systemFileNumRef}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );

  //   return <>User</>;
};

export default CompanyInforamtion;
